
import { FaRegTrashAlt } from 'react-icons/fa';

import { SpaceFileReadModel } from '@client/api';
import { Button, isDefinedString, TableCell, TableRow, Text } from '@client/toolkit';

type SpaceFileItemProps = {
  spaceFile?: SpaceFileReadModel;
  isFetching?: boolean;
  onClickDelete?: (usage: SpaceFileReadModel) => void;
}

export function SpaceFileItem({
  spaceFile,
  isFetching,
  onClickDelete
}: SpaceFileItemProps) {

  return (
    <TableRow verticalAlign="middle">
      <TableCell loading={isFetching}>

        <div className="flex items-center justify-end">
          <div className="flex-1">
            <Text as="div" isEmpty={!isDefinedString(spaceFile?.file?.name)}>
              <strong>{spaceFile?.file?.name}</strong>
            </Text>
          </div>

          <Button
            className="ml-2"
            size="xs"
            color="secondary-light"
            disabled={typeof onClickDelete !== 'function' || isFetching}
            onClick={() => {
              if (typeof onClickDelete !== 'function') return;
              if (spaceFile == null) return;
              onClickDelete(spaceFile);
            }}
          >
            <FaRegTrashAlt />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
